import React, { useState } from 'react';
import { Box, HStack, Icon, Body } from '@hover/blueprint';
import { iPlus } from '@hover/icons';
import anime from 'animejs';
import PricingTooltipsList from '../PricingTooltipsList';
import { PRICING_BASIC_TOOLTIPS } from '../../../../constants';
import BasicsFooter from './BasicsFooter';

const BasicFeaturesMobile: React.FC = () => {
  const [isVisible, setVisible] = useState<boolean>(false);

  const toggleVisible = () => {
    setVisible(!isVisible);
    if (!isVisible) {
      anime({
        duration: 200,
        targets: '#pricing-basic-features-mobile',
        maxHeight: [0, 500],
        paddingTop: [0, 24],
        easing: 'linear',
      });
    } else {
      anime({
        duration: 200,
        targets: '#pricing-basic-features-mobile',
        maxHeight: [500, 0],
        paddingTop: [24, 0],
        easing: 'linear',
      });
    }
  };
  return (
    <Box
      bg="brandBrown.100"
      d={{ base: 'flex', tablet: 'none' }}
      flexDir="column"
    >
      <HStack
        alignItems="center"
        onClick={toggleVisible}
        spacing={400}
        mb="20px"
        mx="auto"
      >
        <Icon
          transform="auto"
          rotate={isVisible ? '45deg' : 0}
          transition="all 0.1s ease-in"
          m={0}
          icon={iPlus}
          size="default"
          strokeWidth="2px"
          color="primary.600"
        />
        <Body isBold color="primary.600">
          {isVisible ? 'Hide' : 'See'} Features
        </Body>
      </HStack>
      <Box
        pt={0}
        id="pricing-basic-features-mobile"
        bg="neutral.0"
        overflow="hidden"
        maxH={0}
        flexDir="column"
        px={200}
      >
        <PricingTooltipsList data={PRICING_BASIC_TOOLTIPS} />
        <BasicsFooter />
      </Box>
    </Box>
  );
};

export default BasicFeaturesMobile;
